export const forceLogout = () => {
  window.location = `${process.env.REACT_APP_AUTH_URL}/oAuth/logout?post_logout_redirect_uri=${document.location.origin}&state=`;
};
